// extracted by mini-css-extract-plugin
export default {"post-like-mini":"post-like-mini_post-like-mini__h2or+","liked-users":"post-like-mini_liked-users__qcKbJ","text":"post-like-mini_text__dw7-h"};